/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Insufficientcredits_Descriptionpaid2Inputs */

const zh_chat_insufficientcredits_descriptionpaid2 = /** @type {(inputs: Chat_Insufficientcredits_Descriptionpaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的积分余额已用完，无法发送消息。请购买更多积分以继续使用。`)
};

const en_chat_insufficientcredits_descriptionpaid2 = /** @type {(inputs: Chat_Insufficientcredits_Descriptionpaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've run out of credits and cannot send messages. Please purchase more credits to continue.`)
};

const es_chat_insufficientcredits_descriptionpaid2 = /** @type {(inputs: Chat_Insufficientcredits_Descriptionpaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te has quedado sin créditos y no puedes enviar mensajes. Compra más créditos para continuar.`)
};

/**
* | output |
* | --- |
* | "You've run out of credits and cannot send messages. Please purchase more credits to continue." |
*
* @param {Chat_Insufficientcredits_Descriptionpaid2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_insufficientcredits_descriptionpaid2 = /** @type {((inputs?: Chat_Insufficientcredits_Descriptionpaid2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Insufficientcredits_Descriptionpaid2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_insufficientcredits_descriptionpaid2(inputs)
	if (locale === "en") return en_chat_insufficientcredits_descriptionpaid2(inputs)
	return es_chat_insufficientcredits_descriptionpaid2(inputs)
});
export { chat_insufficientcredits_descriptionpaid2 as "chat_insufficientCredits_descriptionPaid" }